import { AxiosResponse } from "axios";
import { createSliceSaga } from "../saga-helper";
import { DashboardReducerAction } from "./slice";
import { call, put } from "redux-saga/effects";
import { getDashboardDataService } from "../../services/dashboardServices";
// 

let currentController: AbortController | null = null;

function isCancelError(err: any) {
  return (
    !err ||
    err?.code === "ERR_CANCELED" || // axios v1
    err?.name === "CanceledError" || // axios v1 alternative
    err?.name === "AbortError" || // DOM AbortError
    err?.message === "canceled" ||
    err?.__CANCEL__ === true // axios v0 cancel token
  );
}

const saga = createSliceSaga({
  name: "dashboard-saga-state",
  caseSagas: {
    *getDashboardDataSaga(action: {
      payload: {
        startDate: Date;
        endDate: Date;
        platform: string;
        ad_account_id: null | string;
      };
    }): Generator<any, void, any> {
      if (currentController) {
        try {
          currentController.abort();
        } catch (e) {
          // ignore
        }
        currentController = null;
      }

      const controller = new AbortController();
      currentController = controller;

      try {
        yield put(DashboardReducerAction.setIsLoading(true));

        const response: AxiosResponse = yield call(
          getDashboardDataService,
          action.payload,
          controller.signal
        );

        const { data, status } = response || {};

        if (status === 200) {
          yield put(DashboardReducerAction.setDashboardData(data));
        } else {
     
        console.warn("Dashboard API returned invalid response", { status, data });
        }
      } catch (error: any) {
        if (isCancelError(error)) {
          console.warn("Dashboard API call canceled", error?.message ?? "");
        } else {
          console.error("Dashboard API failed:", error);// optional: yield put(DashboardReducerAction.setError(...))
        }
      } finally {
        if (currentController === controller) {
          yield put(DashboardReducerAction.setIsLoading(false));
          currentController = null;
        } else {
          // If not equal, a new request has started and will manage the loading flag.
          // No action required here.
        }
      }
    },
  },
  sagaType: "takeLatest",
});

export const {
  actions: DashboardSagaAction,
  saga: DashboardSaga,
  name: DashboardSagaName,
} = saga;
